module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAPFBMVEVwmC3VLiRtkyzRLSNrkSsAAAAAaz8KCAEMCgE2LQVJPQZWRwhpVwlsWQm5mRDOESbTrxLlvhTsxBX80RYJx7CiAAAABXRSTlPGxsfHyHL8Id4AAABMSURBVHjazY05EsAgDAMdbsxN/v/XtBEzds128o5kGio36wewFjO9QO+YD12rrFfJKeWypPZm73nL4y3GpvzmORn1H+OInIFTULlYf84YG42Ue8POAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/gh.png
// module id = 830
// module chunks = 0